module.exports = __webpack_public_path__ + "media/images/shelf_preview_landscape-164cf6bbae0aec4cea3afa922de673a4.png";